import React, { useEffect } from 'react'
import { useSearchContext } from '../../context/search.context'
import './SearchHeader.scss'
import { currentLang, handleKeyDownHeader, highlightText, isLight, placeholder } from '../../Common'
import { clickSuggestionItem } from '../../datalayerEvent'

const SearchHeader = () => {
  const [isShowSearch, setIsShowSearch] = React.useState(false)
  const [heightFromTop, setHeightFromTop] = React.useState('0px')
  const { handleSubmit, setSearchValue, searchValue, searchData } = useSearchContext()

  useEffect(() => {
    const element = document.querySelector('header') as HTMLElement | null // Type assertion for null check
    if (element) {
      setHeightFromTop(element.offsetHeight + 'px')
    }
    // if (window.location.pathname.includes('/search-result')) {
    //   if (document.getElementById('searchIconElastic'))
    //     (document.getElementById('searchIconElastic') as HTMLElement).style.display = 'none'
    //   setIsShowSearch(true)
    // }
  }, [])

  if (!isShowSearch)
    return (
      <i
        onClick={(e) => {
          e.preventDefault()
          setIsShowSearch(true)
        }}
        className='icons search'
      ></i>
    )

  return (
    <>
      <div
        className={`search-header ${!isLight && 'search-header--inverted'}`}
        style={{ top: heightFromTop }}
      >
        <div className='container'>
          <form onSubmit={handleSubmit}>
            <div className='search-header__form-wrapper'>
              <div className='search-header__control'>
                <i className='icons search search-header__icon-search'></i>
                <input
                  id='global_search'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => handleKeyDownHeader(e, searchValue, searchData)}
                  type='text'
                  placeholder={placeholder}
                />
              </div>
              <button
                onClick={() => {
                  setIsShowSearch(false)
                  setSearchValue('')
                }}
                className='search-header__close'
              >
                <i className='icons close'></i>
              </button>
            </div>
          </form>

          <div className='search-container'>
            {searchValue && searchData?.hits?.total?.value ? (
              <div className='search-header__results'>
                <ul className='search-header__result-lists'>
                  {searchData?.hits?.hits?.slice(0, 5).map((item) => (
                    <li
                      key={item._id}
                      onClick={() => clickSuggestionItem(item?._source?.title?.[0])}
                    >
                      <a href={`${currentLang}/search-result?q=${item._source.title?.[0]}`}>
                        {highlightText(item?._source?.title?.[0], searchValue)}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            {/* {searchValue && searchData?.hits?.total?.value && window.location.pathname.includes('/search-result') ? (
              <div className='search-header__results'>
                <div className='search-header-records'>
                  {searchData?.hits?.hits.length > 9 && (
                    <>
                      {' '}
                      {10 * page - 10}-{10 * page} of{' '}
                    </>
                  )}
                  {searchData?.hits?.total?.value} results for <span>‘{searchValue}’</span>
                </div>
              </div>
            ) : null} */}

            {searchData?.hits?.hits?.length === 0 ? (
              <div className='search-header__results'>
                <div className='search-header-records'>
                  <div>Your search did not match any results.</div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className='search-overlay' style={{ top: heightFromTop }}></div>
    </>
  )
}

export default SearchHeader
